module.exports = __webpack_public_path__ + "img/arrow-left.9e21f4f1.svg";